import { useCallback, useEffect, useState } from 'react';
import { Award } from 'react-bootstrap-icons';

import { Col, ColProps, Row } from 'antd';
import { Gutter } from 'antd/es/grid/row';

import EmptyState from '@/components/shared/EmptyState';
import PageTitle from '@/components/shared/PageTitle';
import SkeletonBaseCard from '@/components/shared/SkeletonBaseCard';
import Wrapper from '@/components/shared/Wrapper';
import CertificateProps from '@/interfaces/certificates';
import certificateService from '@/services/certificates';

import Card from './Card';

const DEFAULT_ROWS_SPACING = [16, 16] as [Gutter, Gutter];

const DEFAULT_COLUMNS_WIDTH: Pick<ColProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'> = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
  xxl: 6
};

const CertificatesPage = () => {
  const [loading, setLoading] = useState(true);
  const [certificates, setCertificates] = useState<CertificateProps[]>([]);

  const listCertificates = useCallback(async () => {
    try {
      const { data } = await certificateService.list();
      setCertificates(data);
      setLoading(false);
    } catch (error) {
      // TODO: handle error
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    listCertificates();
  }, [listCertificates]);

  const hasCertificates = certificates.length > 0;

  return (
    <Wrapper>
      <PageTitle title='Certificados' />

      {loading && (
        <Row gutter={DEFAULT_ROWS_SPACING}>
          {new Array(8).fill('').map((_, index) => (
            <Col {...DEFAULT_COLUMNS_WIDTH} key={index}>
              <SkeletonBaseCard />
            </Col>
          ))}
        </Row>
      )}

      {!loading && !hasCertificates && (
        <EmptyState
          icon={<Award />}
          title='Todos seus certificados aparecerão aqui...'
          description='Aqui você poderá consultar e baixar todos seus certificados.'
        />
      )}

      {!loading && hasCertificates && (
        <Row gutter={DEFAULT_ROWS_SPACING}>
          {certificates.map(certificate => (
            <Col {...DEFAULT_COLUMNS_WIDTH} key={certificate.id}>
              <Card {...certificate} />
            </Col>
          ))}
        </Row>
      )}
    </Wrapper>
  );
};

export default CertificatesPage;
